import React, { useState } from 'react';
import { deactivateUserMemberships, createClubMembership, getClubBySlug } from '../utils/clubs';
import { getCoachBySlug, createCoachMembership } from '../utils/coaches';
import '../styles/TeamSwitchConfirm.css';

function TeamSwitchConfirm({ userId, pendingClubSlug, pendingCoachSlug, onComplete, onDismiss }) {
  const [loading, setLoading] = useState(false);
  const [resolved, setResolved] = useState(null); // { name }
  const [error, setError] = useState('');

  const teamLabel = pendingClubSlug || pendingCoachSlug || 'this team';

  React.useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        if (pendingClubSlug) {
          const club = await getClubBySlug(pendingClubSlug);
          if (!cancelled && club) setResolved({ name: club.name, type: 'club', id: club.id });
        } else if (pendingCoachSlug) {
          const coach = await getCoachBySlug(pendingCoachSlug);
          if (!cancelled && coach) setResolved({ name: coach.name, type: 'coach', id: coach.id });
        }
      } catch (err) {
        console.error('[TeamSwitchConfirm] Resolve error:', err);
      }
    })();
    return () => { cancelled = true; };
  }, [pendingClubSlug, pendingCoachSlug]);

  const handleConfirm = async () => {
    if (!resolved) return;
    setLoading(true);
    setError('');
    try {
      await deactivateUserMemberships(userId);

      if (resolved.type === 'club') {
        const year = new Date().getFullYear();
        await createClubMembership(userId, resolved.id, year);
      } else {
        await createCoachMembership(userId, resolved.id);
      }

      onComplete();
    } catch (err) {
      console.error('[TeamSwitchConfirm] Error:', err);
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const displayName = resolved?.name || teamLabel;

  return (
    <div className="tsc-overlay">
      <div className="tsc-modal">
        <h3 className="tsc-title">Switch Team?</h3>
        <p className="tsc-message">
          You're joining <strong>{displayName}</strong>. Your current team membership will be deactivated and you'll be moved to the new team.
        </p>
        {error && <p className="tsc-error">{error}</p>}
        <div className="tsc-actions">
          <button type="button" className="tsc-btn tsc-btn-cancel" onClick={onDismiss} disabled={loading}>
            Cancel
          </button>
          <button type="button" className="tsc-btn tsc-btn-confirm" onClick={handleConfirm} disabled={loading || !resolved}>
            {loading ? 'Switching...' : 'Switch Team'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default TeamSwitchConfirm;
